(function () {
  //mobile only
  if (window.innerWidth >= 750) return;

  // Prevent scroll on variant change for mobile
  document.addEventListener('DOMContentLoaded', function () {
    // Find variant selectors
    const variantSelectors = document.querySelectorAll('variant-selects, variant-radios');

    variantSelectors.forEach(function (selector) {
      selector.addEventListener('change', function (e) {
        // Prevent the default scroll behavior
        e.preventDefault();
        e.stopPropagation();
      });
    });

    // Override the scrollIntoView method for product media
    const mediaElements = document.querySelectorAll('.product__media-item, .product__media');
    mediaElements.forEach(function (media) {
      media.scrollIntoView = function () {
        return;
      };
    });
  });
})();
